export default __webpack_public_path__ + "media/color/iost-efd4ecd9.svg";